const last=array=>{if(array.length)return array[array.length-1]};export{last};
